"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get ALLERGY_MAX_ITEMS () {
        return _patients.ALLERGY_MAX_ITEMS;
    },
    get ALLERGY_MAX_LENGTH () {
        return _patients.ALLERGY_MAX_LENGTH;
    },
    get APPOINTMENT_CANCELLATION_REASON_LABELS () {
        return _appointments.APPOINTMENT_CANCELLATION_REASON_LABELS;
    },
    get APPOINTMENT_INVALID_TRANSITION () {
        return _appointments.APPOINTMENT_INVALID_TRANSITION;
    },
    get APPOINTMENT_NOT_RESCHEDULABLE () {
        return _appointments.APPOINTMENT_NOT_RESCHEDULABLE;
    },
    get APPOINTMENT_STATUS_CONFLICT () {
        return _appointments.APPOINTMENT_STATUS_CONFLICT;
    },
    get APPOINTMENT_STATUS_LABELS () {
        return _appointments.APPOINTMENT_STATUS_LABELS;
    },
    get APPOINTMENT_STATUS_TRANSITIONS () {
        return _appointments.APPOINTMENT_STATUS_TRANSITIONS;
    },
    get APPOINTMENT_UPDATE_CONFLICT () {
        return _appointments.APPOINTMENT_UPDATE_CONFLICT;
    },
    get ATTACHMENT_EMPTY () {
        return _attachments.ATTACHMENT_EMPTY;
    },
    get ATTACHMENT_EXTENSIONS_BY_KIND () {
        return _attachments.ATTACHMENT_EXTENSIONS_BY_KIND;
    },
    get ATTACHMENT_FILE_NAME_MAX () {
        return _attachments.ATTACHMENT_FILE_NAME_MAX;
    },
    get ATTACHMENT_INFECTED () {
        return _attachments.ATTACHMENT_INFECTED;
    },
    get ATTACHMENT_KINDS () {
        return _attachments.ATTACHMENT_KINDS;
    },
    get ATTACHMENT_MAX_BYTES () {
        return _attachments.ATTACHMENT_MAX_BYTES;
    },
    get ATTACHMENT_MIME_BY_KIND () {
        return _attachments.ATTACHMENT_MIME_BY_KIND;
    },
    get ATTACHMENT_TOO_LARGE () {
        return _attachments.ATTACHMENT_TOO_LARGE;
    },
    get ATTACHMENT_TYPE_NOT_ALLOWED () {
        return _attachments.ATTACHMENT_TYPE_NOT_ALLOWED;
    },
    get AbilityRuleSchema () {
        return _auth.AbilityRuleSchema;
    },
    get AccessGrantCreatedResponseSchema () {
        return _auth.AccessGrantCreatedResponseSchema;
    },
    get AccessGrantListResponseSchema () {
        return _auth.AccessGrantListResponseSchema;
    },
    get AccessGrantSchema () {
        return _auth.AccessGrantSchema;
    },
    get AllergyStatusSchema () {
        return _patients.AllergyStatusSchema;
    },
    get AppointmentCancellationItemSchema () {
        return _appointments.AppointmentCancellationItemSchema;
    },
    get AppointmentCancellationReasonSchema () {
        return _appointments.AppointmentCancellationReasonSchema;
    },
    get AppointmentCancellationSchema () {
        return _appointments.AppointmentCancellationSchema;
    },
    get AppointmentCreateRequestSchema () {
        return _appointments.AppointmentCreateRequestSchema;
    },
    get AppointmentCreateResponseSchema () {
        return _appointments.AppointmentCreateResponseSchema;
    },
    get AppointmentListCountsSchema () {
        return _appointments.AppointmentListCountsSchema;
    },
    get AppointmentListItemSchema () {
        return _appointments.AppointmentListItemSchema;
    },
    get AppointmentListQuerySchema () {
        return _appointments.AppointmentListQuerySchema;
    },
    get AppointmentListResponseSchema () {
        return _appointments.AppointmentListResponseSchema;
    },
    get AppointmentRescheduleRequestSchema () {
        return _appointments.AppointmentRescheduleRequestSchema;
    },
    get AppointmentRescheduleResponseSchema () {
        return _appointments.AppointmentRescheduleResponseSchema;
    },
    get AppointmentStatusChangeRequestSchema () {
        return _appointments.AppointmentStatusChangeRequestSchema;
    },
    get AppointmentStatusChangeResponseSchema () {
        return _appointments.AppointmentStatusChangeResponseSchema;
    },
    get AppointmentStatusSchema () {
        return _appointments.AppointmentStatusSchema;
    },
    get AttachmentKindSchema () {
        return _attachments.AttachmentKindSchema;
    },
    get AttachmentScanStatusSchema () {
        return _attachments.AttachmentScanStatusSchema;
    },
    get BMI_UNDER_18_NOTE () {
        return _encounters.BMI_UNDER_18_NOTE;
    },
    get BOOKING_WARNING_CODES () {
        return _cliniccalendar.BOOKING_WARNING_CODES;
    },
    get BRANCH_HOLIDAY_EXISTS () {
        return _cliniccalendar.BRANCH_HOLIDAY_EXISTS;
    },
    get BRANCH_HOLIDAY_IN_PAST () {
        return _cliniccalendar.BRANCH_HOLIDAY_IN_PAST;
    },
    get BRANCH_HOLIDAY_LIST_MAX_RANGE_YEARS () {
        return _cliniccalendar.BRANCH_HOLIDAY_LIST_MAX_RANGE_YEARS;
    },
    get BRANCH_HOLIDAY_REASON_MAX_LENGTH () {
        return _cliniccalendar.BRANCH_HOLIDAY_REASON_MAX_LENGTH;
    },
    get BRANCH_HOURS_MAX_INTERVALS_PER_WEEKDAY () {
        return _cliniccalendar.BRANCH_HOURS_MAX_INTERVALS_PER_WEEKDAY;
    },
    get BRANCH_HOURS_VERSION_CONFLICT () {
        return _cliniccalendar.BRANCH_HOURS_VERSION_CONFLICT;
    },
    get BRANCH_LAST_ACTIVE () {
        return _branches.BRANCH_LAST_ACTIVE;
    },
    get BRANCH_NAME_TAKEN () {
        return _branches.BRANCH_NAME_TAKEN;
    },
    get BRANCH_VERSION_CONFLICT () {
        return _branches.BRANCH_VERSION_CONFLICT;
    },
    get BranchCreateRequestSchema () {
        return _branches.BranchCreateRequestSchema;
    },
    get BranchHolidayCreateRequestSchema () {
        return _cliniccalendar.BranchHolidayCreateRequestSchema;
    },
    get BranchHolidayListQuerySchema () {
        return _cliniccalendar.BranchHolidayListQuerySchema;
    },
    get BranchHolidayListResponseSchema () {
        return _cliniccalendar.BranchHolidayListResponseSchema;
    },
    get BranchHolidaySchema () {
        return _cliniccalendar.BranchHolidaySchema;
    },
    get BranchHoursResponseSchema () {
        return _cliniccalendar.BranchHoursResponseSchema;
    },
    get BranchHoursUpdateRequestSchema () {
        return _cliniccalendar.BranchHoursUpdateRequestSchema;
    },
    get BranchListResponseSchema () {
        return _branches.BranchListResponseSchema;
    },
    get BranchSchema () {
        return _branches.BranchSchema;
    },
    get BranchStatusRequestSchema () {
        return _branches.BranchStatusRequestSchema;
    },
    get BranchUpdateRequestSchema () {
        return _branches.BranchUpdateRequestSchema;
    },
    get CHIEF_COMPLAINT_MAX_LENGTH () {
        return _encounters.CHIEF_COMPLAINT_MAX_LENGTH;
    },
    get CIVIL_STATUS_LABELS () {
        return _patients.CIVIL_STATUS_LABELS;
    },
    get CLINIC_PHONE_PATTERN () {
        return _branches.CLINIC_PHONE_PATTERN;
    },
    get CLINIC_POSTAL_CODE_PATTERN () {
        return _branches.CLINIC_POSTAL_CODE_PATTERN;
    },
    get CLINIC_PROFILE_LIMITS () {
        return _branches.CLINIC_PROFILE_LIMITS;
    },
    get CLINIC_TIME_PATTERN () {
        return _cliniccalendar.CLINIC_TIME_PATTERN;
    },
    get CURRENT_FPE_FORM_VERSION () {
        return _fpe.CURRENT_FPE_FORM_VERSION;
    },
    get CivilStatusSchema () {
        return _patients.CivilStatusSchema;
    },
    get ClinicCalendarDayAvailabilitySchema () {
        return _cliniccalendar.ClinicCalendarDayAvailabilitySchema;
    },
    get ClinicCalendarDayBranchSchema () {
        return _cliniccalendar.ClinicCalendarDayBranchSchema;
    },
    get ClinicCalendarDayQuerySchema () {
        return _cliniccalendar.ClinicCalendarDayQuerySchema;
    },
    get ClinicCalendarDayResponseSchema () {
        return _cliniccalendar.ClinicCalendarDayResponseSchema;
    },
    get ClinicProfileSchema () {
        return _branches.ClinicProfileSchema;
    },
    get ClinicTimeSchema () {
        return _cliniccalendar.ClinicTimeSchema;
    },
    get CreateAccessGrantRequestSchema () {
        return _auth.CreateAccessGrantRequestSchema;
    },
    get DIAGNOSES_MAX_ITEMS () {
        return _encounters.DIAGNOSES_MAX_ITEMS;
    },
    get DOCTOR_AVAILABILITY_BRANCH_INVALID () {
        return _cliniccalendar.DOCTOR_AVAILABILITY_BRANCH_INVALID;
    },
    get DOCTOR_AVAILABILITY_DEFAULT_DURATION_MINUTES () {
        return _cliniccalendar.DOCTOR_AVAILABILITY_DEFAULT_DURATION_MINUTES;
    },
    get DOCTOR_AVAILABILITY_LIST_MAX_ITEMS () {
        return _cliniccalendar.DOCTOR_AVAILABILITY_LIST_MAX_ITEMS;
    },
    get DOCTOR_AVAILABILITY_MAX_DURATION_MINUTES () {
        return _cliniccalendar.DOCTOR_AVAILABILITY_MAX_DURATION_MINUTES;
    },
    get DOCTOR_AVAILABILITY_MAX_INTERVALS () {
        return _cliniccalendar.DOCTOR_AVAILABILITY_MAX_INTERVALS;
    },
    get DOCTOR_AVAILABILITY_MAX_INTERVALS_PER_WEEKDAY () {
        return _cliniccalendar.DOCTOR_AVAILABILITY_MAX_INTERVALS_PER_WEEKDAY;
    },
    get DOCTOR_AVAILABILITY_MIN_DURATION_MINUTES () {
        return _cliniccalendar.DOCTOR_AVAILABILITY_MIN_DURATION_MINUTES;
    },
    get DOCTOR_AVAILABILITY_NOT_A_DOCTOR () {
        return _cliniccalendar.DOCTOR_AVAILABILITY_NOT_A_DOCTOR;
    },
    get DOCTOR_AVAILABILITY_NOT_OWN () {
        return _cliniccalendar.DOCTOR_AVAILABILITY_NOT_OWN;
    },
    get DOCTOR_AVAILABILITY_VERSION_CONFLICT () {
        return _cliniccalendar.DOCTOR_AVAILABILITY_VERSION_CONFLICT;
    },
    get DoctorAvailabilityDocumentSchema () {
        return _cliniccalendar.DoctorAvailabilityDocumentSchema;
    },
    get DoctorAvailabilityIntervalInputSchema () {
        return _cliniccalendar.DoctorAvailabilityIntervalInputSchema;
    },
    get DoctorAvailabilityIntervalSchema () {
        return _cliniccalendar.DoctorAvailabilityIntervalSchema;
    },
    get DoctorAvailabilityListItemSchema () {
        return _cliniccalendar.DoctorAvailabilityListItemSchema;
    },
    get DoctorAvailabilityListResponseSchema () {
        return _cliniccalendar.DoctorAvailabilityListResponseSchema;
    },
    get DoctorAvailabilityUpdateRequestSchema () {
        return _cliniccalendar.DoctorAvailabilityUpdateRequestSchema;
    },
    get DoctorAvailabilityWeekSchema () {
        return _cliniccalendar.DoctorAvailabilityWeekSchema;
    },
    get EMRA_ABILITY_SUBJECTS () {
        return _auth.EMRA_ABILITY_SUBJECTS;
    },
    get EMRA_ATTACHMENT_KINDS () {
        return _emra.EMRA_ATTACHMENT_KINDS;
    },
    get EMRA_CHECKSUM_PATTERN () {
        return _emra.EMRA_CHECKSUM_PATTERN;
    },
    get EMRA_LAB_RESULTS_PAGE_MAX_BYTES () {
        return _emra.EMRA_LAB_RESULTS_PAGE_MAX_BYTES;
    },
    get EMRA_LAB_RESULTS_PAGE_MAX_ITEMS () {
        return _emra.EMRA_LAB_RESULTS_PAGE_MAX_ITEMS;
    },
    get EMRA_PATIENT_NAME_MAX_LENGTH () {
        return _emra.EMRA_PATIENT_NAME_MAX_LENGTH;
    },
    get EMRA_RESULT_MAX_ATTACHMENTS () {
        return _emra.EMRA_RESULT_MAX_ATTACHMENTS;
    },
    get EMRA_RESULT_SUMMARY_MAX_LENGTH () {
        return _emra.EMRA_RESULT_SUMMARY_MAX_LENGTH;
    },
    get EMRA_TEST_NAME_MAX_LENGTH () {
        return _emra.EMRA_TEST_NAME_MAX_LENGTH;
    },
    get EMR_ABILITY_ACTIONS () {
        return _auth.EMR_ABILITY_ACTIONS;
    },
    get EMR_ABILITY_SUBJECTS () {
        return _auth.EMR_ABILITY_SUBJECTS;
    },
    get ENCOUNTER_HISTORY_PAGE_SIZE_DEFAULT () {
        return _encounters.ENCOUNTER_HISTORY_PAGE_SIZE_DEFAULT;
    },
    get ENCOUNTER_HISTORY_PAGE_SIZE_MAX () {
        return _encounters.ENCOUNTER_HISTORY_PAGE_SIZE_MAX;
    },
    get ENCOUNTER_LABS_CHANGED () {
        return _encounters.ENCOUNTER_LABS_CHANGED;
    },
    get ENCOUNTER_LAB_LIMIT () {
        return _encounters.ENCOUNTER_LAB_LIMIT;
    },
    get ENCOUNTER_LAB_RESULTS_MAX () {
        return _encounters.ENCOUNTER_LAB_RESULTS_MAX;
    },
    get ENCOUNTER_LAB_SUGGESTED_MAX () {
        return _encounters.ENCOUNTER_LAB_SUGGESTED_MAX;
    },
    get ENCOUNTER_LOCKED () {
        return _encounters.ENCOUNTER_LOCKED;
    },
    get ENCOUNTER_NOT_AUTHOR () {
        return _encounters.ENCOUNTER_NOT_AUTHOR;
    },
    get EmailAddressSchema () {
        return _auth.EmailAddressSchema;
    },
    get EmergencyContactSchema () {
        return _patients.EmergencyContactSchema;
    },
    get EmrLoginRequestSchema () {
        return _auth.EmrLoginRequestSchema;
    },
    get EmraChecksumSchema () {
        return _emra.EmraChecksumSchema;
    },
    get EmraLabResultAttachmentV1Schema () {
        return _emra.EmraLabResultAttachmentV1Schema;
    },
    get EmraLabResultResponseV1Schema () {
        return _emra.EmraLabResultResponseV1Schema;
    },
    get EmraLabResultV1Schema () {
        return _emra.EmraLabResultV1Schema;
    },
    get EmraLabResultsPageV1Schema () {
        return _emra.EmraLabResultsPageV1Schema;
    },
    get EmraMatchKeysV1Schema () {
        return _emra.EmraMatchKeysV1Schema;
    },
    get EmraMatchRefSchema () {
        return _emra.EmraMatchRefSchema;
    },
    get EmraOemPatientRefSchema () {
        return _emra.EmraOemPatientRefSchema;
    },
    get EmraPasswordResetRequestSchema () {
        return _auth.EmraPasswordResetRequestSchema;
    },
    get EmraPatientDetailsV1Schema () {
        return _emra.EmraPatientDetailsV1Schema;
    },
    get EmraResultIdSchema () {
        return _emra.EmraResultIdSchema;
    },
    get EmraSignupRequestSchema () {
        return _auth.EmraSignupRequestSchema;
    },
    get EmraUtcDateTimeSchema () {
        return _emra.EmraUtcDateTimeSchema;
    },
    get EncounterAttachedLabResultSchema () {
        return _encounters.EncounterAttachedLabResultSchema;
    },
    get EncounterDetailSchema () {
        return _encounters.EncounterDetailSchema;
    },
    get EncounterHistoryItemSchema () {
        return _encounters.EncounterHistoryItemSchema;
    },
    get EncounterLabAttachRequestSchema () {
        return _encounters.EncounterLabAttachRequestSchema;
    },
    get EncounterLabAttachResponseSchema () {
        return _encounters.EncounterLabAttachResponseSchema;
    },
    get EncounterLabDetachResponseSchema () {
        return _encounters.EncounterLabDetachResponseSchema;
    },
    get EncounterLabResultsResponseSchema () {
        return _encounters.EncounterLabResultsResponseSchema;
    },
    get EncounterLabSourceStateSchema () {
        return _encounters.EncounterLabSourceStateSchema;
    },
    get EncounterOpenDraftOtherSchema () {
        return _encounters.EncounterOpenDraftOtherSchema;
    },
    get EncounterOpenDraftResponseSchema () {
        return _encounters.EncounterOpenDraftResponseSchema;
    },
    get EncounterSignRequestSchema () {
        return _encounters.EncounterSignRequestSchema;
    },
    get EncounterSignResponseSchema () {
        return _encounters.EncounterSignResponseSchema;
    },
    get EncounterSoapSchema () {
        return _encounters.EncounterSoapSchema;
    },
    get EncounterStartRequestSchema () {
        return _encounters.EncounterStartRequestSchema;
    },
    get EncounterStartResponseSchema () {
        return _encounters.EncounterStartResponseSchema;
    },
    get EncounterStatusSchema () {
        return _encounters.EncounterStatusSchema;
    },
    get EncounterUserRefSchema () {
        return _encounters.EncounterUserRefSchema;
    },
    get EncounterVitalsSchema () {
        return _encounters.EncounterVitalsSchema;
    },
    get FPE_ANSWERS_MAX_BYTES () {
        return _fpe.FPE_ANSWERS_MAX_BYTES;
    },
    get FPE_ENCOUNTER_MISMATCH () {
        return _fpe.FPE_ENCOUNTER_MISMATCH;
    },
    get FPE_FIELD_KEY_PATTERN () {
        return _fpe.FPE_FIELD_KEY_PATTERN;
    },
    get FPE_FORMS () {
        return _fpe.FPE_FORMS;
    },
    get FPE_FORM_UNKNOWN () {
        return _fpe.FPE_FORM_UNKNOWN;
    },
    get FPE_FORM_VERSION_MAX_LENGTH () {
        return _fpe.FPE_FORM_VERSION_MAX_LENGTH;
    },
    get FPE_FORM_VERSION_PATTERN () {
        return _fpe.FPE_FORM_VERSION_PATTERN;
    },
    get FPE_INCOMPLETE () {
        return _fpe.FPE_INCOMPLETE;
    },
    get FPE_LOCKED () {
        return _fpe.FPE_LOCKED;
    },
    get FPE_NOT_FOUND () {
        return _fpe.FPE_NOT_FOUND;
    },
    get FPE_PIN_REQUIRED () {
        return _fpe.FPE_PIN_REQUIRED;
    },
    get FPE_REQUIRED_VITAL_KEYS () {
        return _fpe.FPE_REQUIRED_VITAL_KEYS;
    },
    get FPE_SECTION_KEY_PATTERN () {
        return _fpe.FPE_SECTION_KEY_PATTERN;
    },
    get FPE_TEXT_MAX_LENGTH_DEFAULT () {
        return _fpe.FPE_TEXT_MAX_LENGTH_DEFAULT;
    },
    get FPE_VERSION_CONFLICT () {
        return _fpe.FPE_VERSION_CONFLICT;
    },
    get FPE_VITALS_WHILE_LINKED () {
        return _fpe.FPE_VITALS_WHILE_LINKED;
    },
    get FpeAnswersSchema () {
        return _fpe.FpeAnswersSchema;
    },
    get FpeCompleteRequestSchema () {
        return _fpe.FpeCompleteRequestSchema;
    },
    get FpeCompleteResponseSchema () {
        return _fpe.FpeCompleteResponseSchema;
    },
    get FpeFormVersionSchema () {
        return _fpe.FpeFormVersionSchema;
    },
    get FpeGetResponseSchema () {
        return _fpe.FpeGetResponseSchema;
    },
    get FpeRecordSchema () {
        return _fpe.FpeRecordSchema;
    },
    get FpeSaveRequestSchema () {
        return _fpe.FpeSaveRequestSchema;
    },
    get FpeSaveResponseSchema () {
        return _fpe.FpeSaveResponseSchema;
    },
    get FpeStartResponseSchema () {
        return _fpe.FpeStartResponseSchema;
    },
    get FpeStatusSchema () {
        return _fpe.FpeStatusSchema;
    },
    get FpeStatusSummarySchema () {
        return _fpe.FpeStatusSummarySchema;
    },
    get FpeVitalsSchema () {
        return _fpe.FpeVitalsSchema;
    },
    get FpeVitalsSourceSchema () {
        return _fpe.FpeVitalsSourceSchema;
    },
    get ICD10_CODE_PATTERN () {
        return _icd10.ICD10_CODE_PATTERN;
    },
    get ICD10_CODE_UNKNOWN () {
        return _encounters.ICD10_CODE_UNKNOWN;
    },
    get Icd10CodeSchema () {
        return _icd10.Icd10CodeSchema;
    },
    get Icd10SearchItemSchema () {
        return _icd10.Icd10SearchItemSchema;
    },
    get Icd10SearchRequestSchema () {
        return _icd10.Icd10SearchRequestSchema;
    },
    get Icd10SearchResponseSchema () {
        return _icd10.Icd10SearchResponseSchema;
    },
    get InviteAcceptRequestSchema () {
        return _auth.InviteAcceptRequestSchema;
    },
    get InviteAcceptResponseSchema () {
        return _auth.InviteAcceptResponseSchema;
    },
    get IsoWeekdaySchema () {
        return _cliniccalendar.IsoWeekdaySchema;
    },
    get JwtAccessClaimsSchema () {
        return _auth.JwtAccessClaimsSchema;
    },
    get LAB_RESULT_NOT_ATTACHABLE () {
        return _encounters.LAB_RESULT_NOT_ATTACHABLE;
    },
    get LatestVitalsResponseSchema () {
        return _encounters.LatestVitalsResponseSchema;
    },
    get LatestVitalsSchema () {
        return _encounters.LatestVitalsSchema;
    },
    get LatestVitalsSourceSchema () {
        return _encounters.LatestVitalsSourceSchema;
    },
    get LoginMfaChallengeResponseSchema () {
        return _auth.LoginMfaChallengeResponseSchema;
    },
    get LoginMfaEnrollmentRequiredResponseSchema () {
        return _auth.LoginMfaEnrollmentRequiredResponseSchema;
    },
    get LoginRequestSchema () {
        return _auth.LoginRequestSchema;
    },
    get LoginResponseSchema () {
        return _auth.LoginResponseSchema;
    },
    get LoginTokenPairResponseSchema () {
        return _auth.LoginTokenPairResponseSchema;
    },
    get MEDICATION_CODE_PATTERN () {
        return _medications.MEDICATION_CODE_PATTERN;
    },
    get MEDICATION_FORMS () {
        return _medications.MEDICATION_FORMS;
    },
    get MFA_LOGIN_ERROR_CODES () {
        return _auth.MFA_LOGIN_ERROR_CODES;
    },
    get MFA_LOGIN_MAX_ATTEMPTS () {
        return _auth.MFA_LOGIN_MAX_ATTEMPTS;
    },
    get MINUTES_PER_DAY () {
        return _cliniccalendar.MINUTES_PER_DAY;
    },
    get MedicationCodeSchema () {
        return _medications.MedicationCodeSchema;
    },
    get MedicationFormSchema () {
        return _medications.MedicationFormSchema;
    },
    get MedicationSearchItemSchema () {
        return _medications.MedicationSearchItemSchema;
    },
    get MedicationSearchRequestSchema () {
        return _medications.MedicationSearchRequestSchema;
    },
    get MedicationSearchResponseSchema () {
        return _medications.MedicationSearchResponseSchema;
    },
    get MfaEnrollmentCancelRequestSchema () {
        return _auth.MfaEnrollmentCancelRequestSchema;
    },
    get MfaEnrollmentCompleteRequestSchema () {
        return _auth.MfaEnrollmentCompleteRequestSchema;
    },
    get MfaEnrollmentCompleteResponseSchema () {
        return _auth.MfaEnrollmentCompleteResponseSchema;
    },
    get MfaRecoveryCodeChallengeRequestSchema () {
        return _auth.MfaRecoveryCodeChallengeRequestSchema;
    },
    get MfaRecoveryCodeChallengeResponseSchema () {
        return _auth.MfaRecoveryCodeChallengeResponseSchema;
    },
    get MfaRegenerateRecoveryCodesRequestSchema () {
        return _mfa.MfaRegenerateRecoveryCodesRequestSchema;
    },
    get MfaRegenerateRecoveryCodesResponseSchema () {
        return _mfa.MfaRegenerateRecoveryCodesResponseSchema;
    },
    get MfaStatusResponseSchema () {
        return _mfa.MfaStatusResponseSchema;
    },
    get MfaTotpChallengeRequestSchema () {
        return _auth.MfaTotpChallengeRequestSchema;
    },
    get MfaTotpChallengeResponseSchema () {
        return _auth.MfaTotpChallengeResponseSchema;
    },
    get MfaTotpDisableRequestSchema () {
        return _mfa.MfaTotpDisableRequestSchema;
    },
    get MfaTotpEnrollResponseSchema () {
        return _mfa.MfaTotpEnrollResponseSchema;
    },
    get MfaTotpVerifyEnrollmentRequestSchema () {
        return _mfa.MfaTotpVerifyEnrollmentRequestSchema;
    },
    get MfaTotpVerifyEnrollmentResponseSchema () {
        return _mfa.MfaTotpVerifyEnrollmentResponseSchema;
    },
    get MfaWebAuthnChallengeRequestSchema () {
        return _auth.MfaWebAuthnChallengeRequestSchema;
    },
    get MfaWebAuthnChallengeResponseSchema () {
        return _auth.MfaWebAuthnChallengeResponseSchema;
    },
    get MfaWebAuthnChallengeStartRequestSchema () {
        return _auth.MfaWebAuthnChallengeStartRequestSchema;
    },
    get MfaWebAuthnChallengeStartResponseSchema () {
        return _auth.MfaWebAuthnChallengeStartResponseSchema;
    },
    get MfaWebAuthnChallengeVerifyRequestSchema () {
        return _auth.MfaWebAuthnChallengeVerifyRequestSchema;
    },
    get MfaWebAuthnChallengeVerifyResponseSchema () {
        return _auth.MfaWebAuthnChallengeVerifyResponseSchema;
    },
    get MyAbilitiesResponseSchema () {
        return _auth.MyAbilitiesResponseSchema;
    },
    get NO_KNOWN_ALLERGIES_CONFLICT_MESSAGE () {
        return _patients.NO_KNOWN_ALLERGIES_CONFLICT_MESSAGE;
    },
    get OPEN_DRAFT_OTHERS_MAX_ITEMS () {
        return _encounters.OPEN_DRAFT_OTHERS_MAX_ITEMS;
    },
    get PATIENT_ALERT_LABELS () {
        return _patients.PATIENT_ALERT_LABELS;
    },
    get PATIENT_ALLERGIES_CONFLICT () {
        return _patients.PATIENT_ALLERGIES_CONFLICT;
    },
    get PATIENT_EXPORT_NOT_INCLUDED_V1 () {
        return _patients.PATIENT_EXPORT_NOT_INCLUDED_V1;
    },
    get PATIENT_EXPORT_SCHEMA_VERSION () {
        return _patients.PATIENT_EXPORT_SCHEMA_VERSION;
    },
    get PATIENT_EXPORT_SECTIONS_V1 () {
        return _patients.PATIENT_EXPORT_SECTIONS_V1;
    },
    get PATIENT_STALE () {
        return _patients.PATIENT_STALE;
    },
    get PATIENT_UPDATE_GROUPS () {
        return _patients.PATIENT_UPDATE_GROUPS;
    },
    get PHILHEALTH_PIN_LOCKED () {
        return _patients.PHILHEALTH_PIN_LOCKED;
    },
    get PLAN_EXCERPT_MAX_LENGTH () {
        return _encounters.PLAN_EXCERPT_MAX_LENGTH;
    },
    get PRC_LICENSE_NO_PATTERN () {
        return _prescribers.PRC_LICENSE_NO_PATTERN;
    },
    get PRESCRIBER_LIST_MAX_ITEMS () {
        return _prescribers.PRESCRIBER_LIST_MAX_ITEMS;
    },
    get PRESCRIBER_NOT_A_DOCTOR () {
        return _prescribers.PRESCRIBER_NOT_A_DOCTOR;
    },
    get PRESCRIBER_PROFILE_LIMITS () {
        return _prescribers.PRESCRIBER_PROFILE_LIMITS;
    },
    get PRESCRIBER_PROFILE_VERSION_CONFLICT () {
        return _prescribers.PRESCRIBER_PROFILE_VERSION_CONFLICT;
    },
    get PRESCRIBER_REFERENCE_NO_PATTERN () {
        return _prescribers.PRESCRIBER_REFERENCE_NO_PATTERN;
    },
    get PRESCRIBER_SNAPSHOT_FIELDS () {
        return _prescribers.PRESCRIBER_SNAPSHOT_FIELDS;
    },
    get PRESCRIPTION_FREQUENCIES () {
        return _medications.PRESCRIPTION_FREQUENCIES;
    },
    get PRESCRIPTION_FREQUENCY_KEYS () {
        return _medications.PRESCRIPTION_FREQUENCY_KEYS;
    },
    get PasswordResetConfirmSchema () {
        return _auth.PasswordResetConfirmSchema;
    },
    get PasswordResetRequestSchema () {
        return _auth.PasswordResetRequestSchema;
    },
    get PatientAlertSchema () {
        return _patients.PatientAlertSchema;
    },
    get PatientAllergiesSchema () {
        return _patients.PatientAllergiesSchema;
    },
    get PatientAllergiesUpdateRequestSchema () {
        return _patients.PatientAllergiesUpdateRequestSchema;
    },
    get PatientAllergiesUpdateResponseSchema () {
        return _patients.PatientAllergiesUpdateResponseSchema;
    },
    get PatientAttachmentCreateResponseSchema () {
        return _attachments.PatientAttachmentCreateResponseSchema;
    },
    get PatientAttachmentListResponseSchema () {
        return _attachments.PatientAttachmentListResponseSchema;
    },
    get PatientAttachmentSchema () {
        return _attachments.PatientAttachmentSchema;
    },
    get PatientContactGroupSchema () {
        return _patients.PatientContactGroupSchema;
    },
    get PatientCreateRequestSchema () {
        return _patients.PatientCreateRequestSchema;
    },
    get PatientCreateResponseSchema () {
        return _patients.PatientCreateResponseSchema;
    },
    get PatientDetailSchema () {
        return _patients.PatientDetailSchema;
    },
    get PatientEncounterHistoryQuerySchema () {
        return _encounters.PatientEncounterHistoryQuerySchema;
    },
    get PatientEncounterHistoryResponseSchema () {
        return _encounters.PatientEncounterHistoryResponseSchema;
    },
    get PatientExportFormatSchema () {
        return _patients.PatientExportFormatSchema;
    },
    get PatientExportNotIncludedSchema () {
        return _patients.PatientExportNotIncludedSchema;
    },
    get PatientExportQuerySchema () {
        return _patients.PatientExportQuerySchema;
    },
    get PatientExportSectionSchema () {
        return _patients.PatientExportSectionSchema;
    },
    get PatientGovernmentIdsGroupSchema () {
        return _patients.PatientGovernmentIdsGroupSchema;
    },
    get PatientIdentityGroupSchema () {
        return _patients.PatientIdentityGroupSchema;
    },
    get PatientListFilterSchema () {
        return _patients.PatientListFilterSchema;
    },
    get PatientListItemSchema () {
        return _patients.PatientListItemSchema;
    },
    get PatientRecordExportSchema () {
        return _patients.PatientRecordExportSchema;
    },
    get PatientSearchRequestSchema () {
        return _patients.PatientSearchRequestSchema;
    },
    get PatientSearchResponseSchema () {
        return _patients.PatientSearchResponseSchema;
    },
    get PatientUpdateRequestSchema () {
        return _patients.PatientUpdateRequestSchema;
    },
    get PatientUpdateResponseSchema () {
        return _patients.PatientUpdateResponseSchema;
    },
    get PhilHealthPinSchema () {
        return _patients.PhilHealthPinSchema;
    },
    get PrescriberListItemSchema () {
        return _prescribers.PrescriberListItemSchema;
    },
    get PrescriberListResponseSchema () {
        return _prescribers.PrescriberListResponseSchema;
    },
    get PrescriberProfileNotSetResponseSchema () {
        return _prescribers.PrescriberProfileNotSetResponseSchema;
    },
    get PrescriberProfileResponseSchema () {
        return _prescribers.PrescriberProfileResponseSchema;
    },
    get PrescriberProfileSaveResponseSchema () {
        return _prescribers.PrescriberProfileSaveResponseSchema;
    },
    get PrescriberProfileSetResponseSchema () {
        return _prescribers.PrescriberProfileSetResponseSchema;
    },
    get PrescriberProfileUpdateRequestSchema () {
        return _prescribers.PrescriberProfileUpdateRequestSchema;
    },
    get PrescriberSnapshotSchema () {
        return _prescribers.PrescriberSnapshotSchema;
    },
    get PrescriptionFrequencySchema () {
        return _medications.PrescriptionFrequencySchema;
    },
    get ProviderListItemSchema () {
        return _appointments.ProviderListItemSchema;
    },
    get ProviderListResponseSchema () {
        return _appointments.ProviderListResponseSchema;
    },
    get RefreshTokenResponseSchema () {
        return _auth.RefreshTokenResponseSchema;
    },
    get SOAP_INCOMPLETE () {
        return _encounters.SOAP_INCOMPLETE;
    },
    get SOAP_TEXT_MAX_LENGTH () {
        return _encounters.SOAP_TEXT_MAX_LENGTH;
    },
    get SOAP_VERSION_CONFLICT () {
        return _encounters.SOAP_VERSION_CONFLICT;
    },
    get SOLID_MEDICATION_FORMS () {
        return _medications.SOLID_MEDICATION_FORMS;
    },
    get SignupRequestSchema () {
        return _auth.SignupRequestSchema;
    },
    get SignupResponseSchema () {
        return _auth.SignupResponseSchema;
    },
    get SoapUpdateRequestSchema () {
        return _encounters.SoapUpdateRequestSchema;
    },
    get SoapUpdateResponseSchema () {
        return _encounters.SoapUpdateResponseSchema;
    },
    get SourceOemSchema () {
        return _emra.SourceOemSchema;
    },
    get TENANT_ACCESS_ERROR_CODES () {
        return _auth.TENANT_ACCESS_ERROR_CODES;
    },
    get TENANT_ACCESS_HEADER () {
        return _auth.TENANT_ACCESS_HEADER;
    },
    get TENANT_ACCESS_REASON_CODES () {
        return _auth.TENANT_ACCESS_REASON_CODES;
    },
    get TICKET_REF_PATTERN () {
        return _auth.TICKET_REF_PATTERN;
    },
    get TokenPairSchema () {
        return _auth.TokenPairSchema;
    },
    get VISIT_TYPE_LABELS () {
        return _appointments.VISIT_TYPE_LABELS;
    },
    get VITALS_RANGES () {
        return _encounters.VITALS_RANGES;
    },
    get VITALS_VERSION_CONFLICT () {
        return _encounters.VITALS_VERSION_CONFLICT;
    },
    get VerifyEmailRequestSchema () {
        return _auth.VerifyEmailRequestSchema;
    },
    get VerifyEmailResponseSchema () {
        return _auth.VerifyEmailResponseSchema;
    },
    get VisitTypeSchema () {
        return _appointments.VisitTypeSchema;
    },
    get VitalsInputSchema () {
        return _encounters.VitalsInputSchema;
    },
    get VitalsSaveRequestSchema () {
        return _encounters.VitalsSaveRequestSchema;
    },
    get VitalsSaveResponseSchema () {
        return _encounters.VitalsSaveResponseSchema;
    },
    get WeeklyHoursIntervalSchema () {
        return _cliniccalendar.WeeklyHoursIntervalSchema;
    },
    get WeeklyHoursSchema () {
        return _cliniccalendar.WeeklyHoursSchema;
    },
    get YAKAP_FPE_V0 () {
        return _fpe.YAKAP_FPE_V0;
    },
    get addYearsToCalendarDate () {
        return _cliniccalendar.addYearsToCalendarDate;
    },
    get bmiCategory () {
        return _encounters.bmiCategory;
    },
    get buildFpeSchemas () {
        return _fpe.buildFpeSchemas;
    },
    get canTransition () {
        return _appointments.canTransition;
    },
    get clinicDayOpeningWindow () {
        return _cliniccalendar.clinicDayOpeningWindow;
    },
    get clinicTimeToMinutes () {
        return _cliniccalendar.clinicTimeToMinutes;
    },
    get computeBmi () {
        return _encounters.computeBmi;
    },
    get createFpeFormRegistry () {
        return _fpe.createFpeFormRegistry;
    },
    get evaluateBookingWarnings () {
        return _cliniccalendar.evaluateBookingWarnings;
    },
    get findOverlappingWeekday () {
        return _cliniccalendar.findOverlappingWeekday;
    },
    get fpeFormRegistry () {
        return _fpe.fpeFormRegistry;
    },
    get getFpeForm () {
        return _fpe.getFpeForm;
    },
    get isCustomFpeFieldKind () {
        return _fpe.isCustomFpeFieldKind;
    },
    get isFpeFieldVisible () {
        return _fpe.isFpeFieldVisible;
    },
    get isoWeekdayOfDate () {
        return _cliniccalendar.isoWeekdayOfDate;
    },
    get maskPhilsysNumber () {
        return _patients.maskPhilsysNumber;
    },
    get mergeTimeIntervals () {
        return _cliniccalendar.mergeTimeIntervals;
    },
    get missingFpeVitals () {
        return _fpe.missingFpeVitals;
    },
    get normalizePhMobile () {
        return _patients.normalizePhMobile;
    },
    get normalizePhilsysNumber () {
        return _patients.normalizePhilsysNumber;
    },
    get normalizePrcLicenseNo () {
        return _prescribers.normalizePrcLicenseNo;
    },
    get normalizePrescriberReferenceNo () {
        return _prescribers.normalizePrescriberReferenceNo;
    },
    get parseBloodPressure () {
        return _encounters.parseBloodPressure;
    },
    get patientExportFilename () {
        return _patients.patientExportFilename;
    },
    get planExcerpt () {
        return _encounters.planExcerpt;
    },
    get resolveBranchHolidayRange () {
        return _cliniccalendar.resolveBranchHolidayRange;
    },
    get resolveDefaultDurationMinutes () {
        return _cliniccalendar.resolveDefaultDurationMinutes;
    },
    get toCanonicalPhilhealthPin () {
        return _patients.toCanonicalPhilhealthPin;
    },
    get validateFpeFormDescriptor () {
        return _fpe.validateFpeFormDescriptor;
    }
});
const _auth = require("./auth");
const _mfa = require("./mfa");
const _patients = require("./patients");
const _appointments = require("./appointments");
const _attachments = require("./attachments");
_export_star(require("./lab-results"), exports);
const _encounters = require("./encounters");
const _fpe = require("./fpe");
const _icd10 = require("./icd10");
const _branches = require("./branches");
const _prescribers = require("./prescribers");
const _medications = require("./medications");
const _cliniccalendar = require("./clinic-calendar");
_export_star(require("./prescriptions"), exports);
const _emra = require("./emra");
_export_star(require("./tenants"), exports);
function _export_star(from, to) {
    Object.keys(from).forEach(function(k) {
        if (k !== "default" && !Object.prototype.hasOwnProperty.call(to, k)) {
            Object.defineProperty(to, k, {
                enumerable: true,
                get: function() {
                    return from[k];
                }
            });
        }
    });
    return from;
}
